export const salesChartData = {
    monthly: [
        {hKey: 'Jan', Sent: 300, Opened: 150},
        {hKey: 'Feb', Sent: 400, Opened: 200},
        {hKey: 'Mar', Sent: 350, Opened: 175},
        {hKey: 'Apr', Sent: 500, Opened: 250},
        {hKey: 'May', Sent: 300, Opened: 150},
        {hKey: 'Jun', Sent: 450, Opened: 225},
        {hKey: 'Jul', Sent: 500, Opened: 250},
        {hKey: 'Aug', Sent: 650, Opened: 375},
        {hKey: 'Sep', Sent: 500, Opened: 300},
        {hKey: 'Oct', Sent: 700, Opened: 350},
        {hKey: 'Nov', Sent: 450, Opened: 225},
        {hKey: 'Dec', Sent: 300, Opened: 200},
    ],
    yearly: [
        {hKey: '2011', Sent: 250, Opened: 125},
        {hKey: '2012', Sent: 350, Opened: 175},
        {hKey: '2013', Sent: 320, Opened: 160},
        {hKey: '2014', Sent: 400, Opened: 200},
        {hKey: '2015', Sent: 550, Opened: 275},
        {hKey: '2016', Sent: 450, Opened: 225},
        {hKey: '2017', Sent: 600, Opened: 375},
        {hKey: '2018', Sent: 400, Opened: 300},
        {hKey: '2019', Sent: 500, Opened: 350},
        {hKey: '2020', Sent: 650, Opened: 225},
        {hKey: '2021', Sent: 450, Opened: 300}
    ]
};
